module.exports = require("util");


//////////////////
// WEBPACK FOOTER
// external "util"
// module id = util
// module chunks = 5